export default "assets/images/icons/close-74221ce1.svg";